import { Injectable } from "@angular/core";
import { KeycloakHelperService } from "./keycloak.helper.service";
import { CountryCodeEnum } from "@shared/enums";
import { MaskService } from "./mask.service";

const locales: Record<CountryCodeEnum, string> = {
  [CountryCodeEnum.BRAZIL]: "pt-BR",
  [CountryCodeEnum.ARGENTINA]: "pt-BR",
  [CountryCodeEnum.UNITED_STATES]: "en-US",
  [CountryCodeEnum.NEDERLANDS]: "en-US"
};

@Injectable({
  providedIn: "root"
})
export class MonetaryService {
  locale = locales[CountryCodeEnum.BRAZIL];

  constructor(
    private keycloakHelperService: KeycloakHelperService,
    private maskService: MaskService
  ) {
    this.locale = locales[this.keycloakHelperService.getUserCountryCode()];
  }

  floatToMonetaryString(value: number) {
    if (!value) {
      value = 0;
    }
    return value.toLocaleString(this.locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  formatValueReceivedToUserMask(value: number | null | undefined): string {
    if (!value || value === null || value === undefined) {
      return "0";
    }

    let stringValue = value.toString();
    const hasBackendSeparator = stringValue.includes(".");
    if (hasBackendSeparator) {
      stringValue = stringValue.replace(
        ".",
        this.maskService.getDecimalSeparator()
      );
    }
    return stringValue;
  }

  monetaryStringToFloat(value: string): number {
    if (typeof value === "string") {
      value = value.split(this.maskService.getThousandSeparator()).join("");
      value = value.split(this.maskService.getDecimalSeparator()).join(".");
      return parseFloat(value);
    }
    return parseFloat(value);
  }
}
